/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'M4.3 11.3c1-1 4.1-4.3 7.7-4.3 3.3 0 6.2 2.7 7.6 4.3.4.4.4 1 0 1.4-.6.8-3.9 4.3-7.6 4.3-3.6 0-6.8-3.3-7.7-4.3a1 1 0 0 1 0-1.4ZM2.8 14c1.3 1.5 4.8 5 9.2 5 4.5 0 8.1-3.8 9.1-5a3 3 0 0 0 0-4c-1.6-1.9-5-5-9-5-4.4 0-8 3.5-9.3 5a3 3 0 0 0 0 4Zm7.5-1.9a1.7 1.7 0 1 1 3.4 0 1.7 1.7 0 0 1-3.4 0Zm-2 0a3.7 3.7 0 1 0 7.4 0 3.7 3.7 0 0 0-7.4 0Z',
  DEV ? 'EyeIcon' : '',
  '',
  false,
);
